const searchFields = [
  { label: 'agent_name', searchKey: 'agentName' },
  { label: 'branch_name', searchKey: 'branchName' },
  { label: 'performance_tag', searchKey: 'performanceTag' },
  { label: 'team_name', searchKey: 'teamName' },
  { label: 'campaign_name', searchKey: 'campaignName' },
  {
    label: 'property_name',
    searchKey: 'propertyName',
    componentType: 'autocomplete',
    component: 'PropertyComponent',
  },
];

export default searchFields;
